import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageHeader } from "@/components/Kit";
import WebsiteSettings from "@/pages/school/WebsiteSettings";
import { ArrowLeft } from "lucide-react";

export default function SchoolWebsite() {
  const { id } = useParams();
  const { data: schools = [] } = useQuery({ queryKey: ["sa-schools"], queryFn: async () => (await api.get("/superadmin/schools")).data });
  const school = schools.find((s) => s.id === id);
  return (
    <div data-testid="sa-website-page">
      <Link to="/super/schools" className="mb-3 inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-white" data-testid="sa-back-schools"><ArrowLeft size={15} /> School Management</Link>
      <PageHeader title={`Public Website — ${school?.name || ""}`} subtitle="Edit the school's public portal content, cover photo, gallery and fee structure" />
      {school && <WebsiteSettings schoolId={school.id} schoolCode={school.code} />}
    </div>
  );
}
